<template>
  <div class="yakukyari1st-top-search_wrap">
    <div class="yakukyari1st-top-search_tap">
      <ul class="top-search_taplist">
        <li
          v-for="(tab, index) in tabs"
          v-bind:key="tab.class"
          v-bind:class="['top_taplist-twocol taplist-twocol', { active: currentTabName === tab.class }]"
          v-on:click="changeTab(tab)"
          >
          {{ tab.name }}
        </li>
      </ul>
    </div>

    <div>
      <keep-alive>
        <component :is="currentTab"
                   :tabName="currentTabName"
                   :formParamsName="formParamsName"
                   :areas="areas"
                   :prefectures="prefectures"
                   :conditionTypes="conditionTypes"
                   :path="currentPath"
                   :clearAllAreas="clearAllAreas"
                   :pcRecentSearches="pcRecentSearches"
                   :spRecentSearches="spRecentSearches"
                   :recentSearchPath="recentSearchPath"
                   :key="currentTabName"
                   :pcrContent="pcrContent"
                   />
      </keep-alive>
    </div>
  </div>
</template>

<script setup>
import { ref, provide, markRaw } from 'vue'
import Internship from '@component_path/search-contents/top/components/tab.vue'
import Company from '@component_path/search-contents/top/components/tab.vue'
import CareerFair from '@component_path/search-contents/top/components/tab.vue'

const props = defineProps({
  tabs: { type: Array, required: true },
  areas: { type: Array, required: true },
  months: { type: Array, required: true },
  prefectures: { type: Array, required: true },
  conditionTypes: { type: Array, required: true },
  clearAllAreas: { type: Object } //条件クリア用
})
provide('areas', props.areas)
provide('clearAllAreas', props.clearAllAreas)
provide('conditionTypes', props.conditionTypes)
provide('months', props.months)

const currentTab = ref(null)
const currentTabName = ref(props.tabs[0].class)
const currentPath = ref(props.tabs[0].form_path)
const pcRecentSearches = ref(props.tabs[0].recent_search_texts.pc)
const spRecentSearches = ref(props.tabs[0].recent_search_texts.sp)
const recentSearchPath = ref(props.tabs[0].recent_search_path)
const formParamsName = ref(props.tabs[0].form_params_name)
const pcrContent = ref(props.tabs[0].pcr_content)

const lookup = {
  Internship,
  Company,
  CareerFair
}

const changeTab = (tab) => {
  currentTab.value = markRaw(lookup[tab.class])
  currentTabName.value = tab.class
  currentPath.value = tab.form_path
  formParamsName.value = tab.form_params_name
  // 最近の検索の項目
  pcRecentSearches.value = tab.recent_search_texts.pc
  spRecentSearches.value = tab.recent_search_texts.sp
  recentSearchPath.value = tab.recent_search_path
  pcrContent.value = tab.pcr_content
}

// 初期表示
changeTab(props.tabs[0])
</script>